
import { defineComponent } from 'vue'
import { useFormModule } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'agreement-form-field-additional-info',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        }
    }
})
